import getApi from '../../../../api/apisauceConfig'
import { HealthcareSetting } from '../../../../model/Efficience'

export const getHealthcareSettings = () => getApi().get<HealthcareSetting[]>('/healthcare_settings')
